var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('b-container',{staticClass:"video"},[_c('sliceheadline',{attrs:{"item":_vm.item}}),_c('sliceembed',{attrs:{"url":_vm.item.data.video}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }